module.exports = __webpack_public_path__ + "static/media/8.73fcb5a3.jpg";